import { render, staticRenderFns } from "./PinboardModal.vue?vue&type=template&id=9d33d354&scoped=true&"
import script from "./PinboardModal.vue?vue&type=script&lang=ts&"
export * from "./PinboardModal.vue?vue&type=script&lang=ts&"
import style0 from "./PinboardModal.vue?vue&type=style&index=0&id=9d33d354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d33d354",
  null
  
)

export default component.exports